require('./jqgrid/css/ui.jqgrid.css');
require('./jqgrid/css/ui.multiselect.css');

require('./jqgrid/js/i18n/grid.locale-' + LANG + '.js');
require('./jqgrid/js/jquery.jqGrid.min.4.5.2.js');

require('./index.css');
var locale = require('./i18n');

Enhancer.registerWidget( {
    construct: function( prof, zContext ) {
        var that = this;
        that._tabid = that.id() + '_tab';
        that.lastSelectedRowId;
        // prof.width = that.$div.width();

        prof.url = that.getSourceDataUrl(prof.dataSourceID);

        var params = prof.params;

        that.prof = prof;
        that.zContext = zContext;
        var $g = $( '<table>' ).attr( 'id',  that._tabid ).appendTo( that.$div );

        that.$grid = $g;
        prof.height = parseInt( that.$div.css( 'height' ).match( /\d+/ )[0] ) 
                    - 25 - ( prof.pager != 'none' || prof.hasToolbar ? 26 : 0 )
                    - ( prof.toppager ? 26 : 0 )
                    - ( prof.filter === true ? 23 : 0 )
                    - ( prof.setGroupHeaders !== false ? 23 : 0 )
                    - ( prof.footerrow ? 22 : 0 );

        if ( prof.pager !== 'none' ) {
            that._pagerId = that.id() + '_pager';
            prof.pager = '#' + that._pagerId;
            $( '<div>' ).attr( 'id', that._pagerId ).appendTo( that.$div );
        } else {
            delete prof.pager;
            prof.rowNum = 3888;
        }

        prof.beforeRequest = function() {
            var page = $g.getGridParam( 'page' );
            var rowNum = $g.getGridParam( 'rowNum' );
            var srcId = prof.dataSourceID;
            var criteria = {
                filters: that.getFilters(),
                page: page,
                paged: !!that.prof.pager,
                rowNum: rowNum,
                sortBy: that.getCurrentSort(),
                format: 'jqgrid'
            };
            that.getSourceData(srcId, criteria, function(data) {
                 $g[0].addJSONData(data);
            });
            return false;
        };
        prof.onSelectRow = function( rowid ) {
            that.lastSelectedRowId = rowid;
            that.trig( 'onSelectRow' );
        };
        prof.ondblClickRow = function( rowid ) {
            that.lastSelectedRowId = rowid;
            that.trig( 'ondblClickRow' );
        };
        prof.onSelectAll = function( rowids, status ) {
            that.lastSelectedRowId = null;
        };
        prof.gridComplete = function() {
            that.lastSelectedRowId = 0;
            // set default value
            that.$grid.setSelection(0, true);
            if (!that._initialized) {
                that.__initialized = true;
                that.trig( 'complete' );
            }
            // summary footer
            if (prof.footerrow) {
                var colModel = prof.colModel;
                var data = {};
                for (var i in colModel) {
                    if (colModel[i].summaryType) {
                        data[colModel[i].name] = that.$grid.jqGrid(
                            'getCol', colModel[i].name, false, colModel[i].summaryType)
                    }
                }

                that.$grid.jqGrid('footerData', 'set', data);
            }
            that.trig( 'onDataComplete' );
        };
        prof.onSortCol = function( index, iCol, sortorder ) {
            that.setCurrentSort( index + ' ' + sortorder );
        };
        prof.jqGridToolbarBeforeSearch = function() {
            alert('filter...');
        };

        this.setCurrentSort( prof.sortBy );

        $g.jqGrid( prof );

        $g.jqGrid('setGridWidth', that.$div.width());

        if ( prof.frozenColumn ) {
            $g.jqGrid( 'setFrozenColumns' );
        }
        if ( typeof prof.setGroupHeaders === 'object' ) {
            $g.jqGrid( 'setGroupHeaders', prof.setGroupHeaders );
        }
        if ( prof.filter === true ) {
            $g.jqGrid( 'filterToolbar', {stringResult: true, searchOnEnter : false});
        }
        if ( prof.sortableRows ) { 
            $g.jqGrid( 'sortableRows' );
        }

        // init toolbar
        this.initToolbar( prof );

        this.$div.find( '>div.ui-widget-content' )
            .css( 'border-right', 'none' )
            .css( 'border-left', 'none' )
            .removeClass( 'ui-corner-all' );

    },
    setCurrentSort: function( sort ) {
        this.currentSort = sort;
    },
    getCurrentSort: function() {
        var sortname = this.$grid.getGridParam( 'sortname' );
        var sortorder = this.$grid.getGridParam( 'sortorder' );
        return (this.currentSort
            || ( sortname ? sortname + ( sortorder ? ' ' + sortorder : '' ) : '' ))
                .replace(/\s*\,\s*$/, '');
    },
    initToolbar: function( prof ) {
        if ( !prof.hasToolbar ) {
            return;
        }
        var that = this;
        var hasPager = !!prof.pager;
        var $tools = $( '<ul>' ).addClass('enhancer-jqgrid-tools');
        if ( prof.advSort ) {
            $( '<li>' )
                .attr( 'title', locale('advSort') )
                .append( '<span class="ui-icon ui-icon-arrowthick-2-n-s"></span>' )
                .append( hasPager ? '' : locale('advSort') )
                .appendTo( $tools )
                .click( function() {
                    that.sortGrid();
                } );
        }
        if ( prof.viewCols ) {
            $( '<li>' )
                .attr( 'title', locale('viewCols') )
                .append( '<span class="ui-icon ui-icon-circle-zoomin"></span>' )
                .append( hasPager ? '' : locale('viewCols') )
                .appendTo( $tools )
                .click( function() {
                    that.chooseCols();
                } );
        }
        
        if ( prof.search !== 'none' ) {
            $( '<li>' )
                .attr( 'title', locale('search') )
                .append( '<span class="ui-icon ui-icon-search"></span>' )
                .append( hasPager ? '' : locale('search') )
                .appendTo( $tools )
                .click( function() {
                    that.search();
                } );
        }
        
        if ( prof.exportable ) {
            $( '<li>' )
                .attr( 'title', locale('export') )
                .append( '<span class="ui-icon ui-icon-arrowthickstop-1-s"></span>' )
                .append( hasPager ? '' : locale('export') )
                .appendTo( $tools )
                .click( function() {
                    that.exportExcel();
                } );
        }
        
        if ( prof.refreshable ) {
            $( '<li>' )
                .attr( 'title', locale('refresh') )
                .append( '<span class="ui-icon ui-icon-refresh"></span>' )
                .append( hasPager ? '' : locale('refresh') )
                .appendTo( $tools )
                .click( function() {
                    that.refreshGrid();
                } );
        }
        
        if ( prof.resetable ) {
            $( '<li>' )
                .attr( 'title', locale('reset') )
                .append( '<span class="ui-icon ui-icon-arrowreturnthick-1-w"></span>' )
                .append( hasPager ? '' : locale('reset') )
                .appendTo( $tools )
                .click( function() {
                    that.resetGrid();
                } );
        }
        
        $tools.find( 'li' )
            .hover( function() {
                $(this).addClass( 'ui-state-hover' ) 
            }, function() {
                $(this).removeClass( 'ui-state-hover' )
            } );
        
        var $loc = $( '#' + this.id() + '_pager_left' );
        if ( $loc.size() === 0 ) {
            $( '<div class="ui-state-default"></div>' )
                .attr('id', this.id() + '_toolbar"')
                .addClass('enhaner-jqgrid-tools-wrapper')
                .append( $tools )
                .appendTo( this.$div );
        } else {
            $loc.append( $tools );
        }
    },
    search: function() {
        var search = this.prof.search;
        this.$grid.jqGrid( 'searchGrid',
            {   sopt:['cn','bw','eq','ne','lt','gt','ew']
                , multipleSearch: search != 'single'
                , multipleGroup: search == 'complex'
            }
        );
    },
    chooseCols: function() {
        if ( this.$chooser ) {
            this.$chooser.dialog( 'open' );
            return;
        }
        var colModel = this.prof.colModel;
        var chooserId = this.id() + '_chooser';
        var $chooser = $( '<div id="' + chooserId+ '"></div>' )
                .addClass('enhancer-jqgrid-cols-chooser')
                .appendTo( this.$div );

        var $colList = $( '<ul>' ).appendTo( $chooser );

        var col;
        for ( var i = 0; i < colModel.length; i++ ) {
            col = colModel[ i ];
            $( '<li class="ui-state-default">' + col.label + '</li>' )
                .append('<input checked="checked" num="' + i + '" cn="' 
                    + col.name + '" type="checkbox">')
                .appendTo( $colList );
        }
        // $colList.sortable();
        this.$chooser = $chooser;
        var that = this;
        this.$chooser.dialog( {
            title: locale('chooseCols'),
            width: 240,
            height: 300,
            modal: true,
            buttons:[ {
                text: locale('cancel'),
                icons: {
                    primary: 'ui-icon-cancel'
                },
                click: function() {
                    $( this ).dialog( 'close' );
                }
            }, {
                text: locale('confirm'),
                icons: {
                    primary: 'ui-icon-check'
                },
                click: function() {
                    // var perm = [];
                    $(this).find( 'ul>li>input' ).each( function() {
                        if ( $(this).prop('checked') ) {
                            that.$grid.jqGrid( 'showCol', $(this).attr( 'cn' ) );
                        } else {
                            that.$grid.jqGrid( 'hideCol',  $(this).attr( 'cn' ) );
                        }
                    } );
                    $(this).dialog( 'close', perm );
                }
            } ]
        } );
    },
    sortGrid: function() {
        if ( this.$sorter ) {
            this.$sorter.dialog( 'open' );
            return;
        }
        var colModel = this.prof.colModel;
        var sorterId = this.id() + '_sorter';
        var $sorter = $( '<div id="' + sorterId + '" ></div>' )
                .addClass('enhancer-jqgrid-sorter')
                // .append('<span class="ui-state-highlight">'
                //     + '<a class="ui-icon ui-icon-info"></a>'
                //     + locale('sorterTips')
                //     + '</span>')
                .appendTo( this.$div );

        // left list
        var $left = $( '<ul class="connectedSortable sortable left"></ul>' )
                .attr('id', sorterId + '_left')
                .addClass('ui-widget-content')
                .appendTo( $sorter );
        var col;
        for ( var i = 0; i < colModel.length; i++ ) {
            col = colModel[ i ];
            $( '<li class="ui-state-default"></li>' )
                .attr( 'order', 'desc' )
                .attr( 'cn', col.name )
                .text( col[ 'label' ] )
                .append(
                    $( '<span class="ui-icon ui-icon-arrowthick-1-s"></span>' )
                        .attr( 'title', locale('ascDesc') )
                        .click( function() {
                            var $p = $(this).parent();
                            if ( $p.attr( 'order' ) === 'desc' ) {
                                $p.attr( 'order', 'asc' );
                                $(this).removeClass( "ui-icon-arrowthick-1-s" )
                                    .addClass( 'ui-icon-arrowthick-1-n' );
                            } else {
                                $p.attr( 'order', 'desc' );
                                $(this).removeClass( 'ui-icon-arrowthick-1-n' )
                                    .addClass( 'ui-icon-arrowthick-1-s' );
                            }
                        } )
                )
                .appendTo( $left );
        }

        // right list
        var $right = $( '<ul class="connectedSortable sortable right"></ul>' )
                .addClass('ui-widget-content')
                .attr('id', sorterId + '_right')
                .appendTo( $sorter );
        
        $( '#' + sorterId + '_left, #' + sorterId + '_right' ).sortable( {
            connectWith: '.connectedSortable',
            placeholder: 'ui-state-highlight'
        } ).disableSelection();

        this.$sorter = $sorter;
        var that = this;
        $sorter.dialog( {
            title: locale('advSort'),
            width: 460,
            height: 390,
            resizable: false,
            modal: true,
            buttons: [ {
                text: locale('cancel'),
                icons: {
                    primary: 'ui-icon-cancel'
                },
                click: function() {
                    $( this ).dialog( 'close' );
                }
            }, {
                text: locale('sort'),
                icons: {
                    primary: 'ui-icon-arrowthick-2-n-s'
                },
                click: function() {
                    var sortStr = [];
                    $(this).find( 'ul:last>li' ).each( function() {
                        sortStr.push( 
                            $(this).attr( 'cn' )
                                + ' '
                                + $(this).attr( 'order' ) );
                    } );
                    sortStr = sortStr.join(',');
                    that.setCurrentSort( sortStr );
                    that.$grid.trigger( 'reloadGrid' );
                    $( this ).dialog( 'close' );
                }
            } ]
        } );
    },
    exportExcel: function() {
        var that = this;
        var colModel = [];
        var cml = that.prof.colModel;
        for ( var i = 0; i < cml.length; i++ ) {
            colModel.push( {
                id: cml[i].name,
                name: cml[i].label, 
                type: cml[i].dataType,
                formatCode: cml[i].formatter === 'currency' ? '0.00' : 'General'
            } );
        }
        var paged = !!that.prof.pager;

        function exp() {
            var criteria = {
                filters: that.getFilters(),
                params: that.zContext.vals( that.prof.params ),
                format: 'xlsx',
                colModel: colModel,
                paged: paged,
                page: that.$grid.getGridParam( 'page' ),
                rowNum: that.$grid.getGridParam( 'rowNum' ),
                sortBy: that.getCurrentSort()
            };
            that.exportSourceData(that.prof.dataSourceID, criteria);
        }
        
        if ( paged ) {
            $( '<div class="enhancer-jqgrid-export">' + locale('exportTips') + '</div>' ).dialog( {
                title: '',
                width: 260,
                height: 120,
                modal: true,
                buttons: [ {
                    text: locale('exportCurr'),
                    icons: {
                        primary: 'ui-icon-arrowthickstop-1-s'
                    },
                    click: function() {
                         exp();
                         $(this).dialog( 'destroy' ).remove();
                    }
                }, {
                    text: locale('exportAll'),
                    icons: {
                        primary: 'ui-icon-arrowthickstop-1-s'
                    },
                    click: function() {
                        paged = false;
                        exp();
                        $(this).dialog( 'destroy' ).remove();
                    }
                } ]
            } ).prev().remove();
        } else { // unpaged, export all
            exp();
        }
    },
    refreshGrid: function() {
        this.$grid.trigger( 'reloadGrid' );
    },
    resetGrid: function() {
        this.reset();
    },
    getData: function() {
        var $grid = this.$grid;
        var data = this.lastSelectedRowId
             ? $grid.getRowData( this.lastSelectedRowId ) : {};

        data.LAST_SELECTED_ROW_ID = this.lastSelectedRowId;

        if ( $grid.getGridParam( 'multiselect' ) === true ) {
            var rowIDs = $grid.getGridParam( 'selarrrow' );
            var colNames = this.prof.multiData;
            var selectedRows = [];
            var selectedMatrix = [];

            for ( var i in rowIDs ) {
                var rd = $grid.getRowData( rowIDs[ i ] );
                var row = {};
                var arr = [];
                var cn;
                for ( var i in colNames ) {
                    cn = colNames[i];
                    row[ cn ] = rd[ cn ];
                    arr.push( rd[ cn ] );
                }
                selectedRows.push( row );
                selectedMatrix.push( arr );
            }
            data.SELECTED_ROWS = selectedRows;
            data.SELECTED_ROWS_COUNT = selectedRows.length;
            data.SELECTED_MATRIX = selectedMatrix;
        }
        return data;
    },
    getFilters: function() {
        var postData = this.$grid.getGridParam( 'postData' );
        if ( !postData.filters && !postData.searchField ) {
            return '';
        }
        return postData.filters
            ? JSON.parse(postData.filters)
            : {
                groupOp: 'AND',
                rules: [{
                    field: postData.searchField, 
                    op: postData.searchOper,
                    data: postData.searchString
                }]
            };
    },
    isReady: function() {
        var $grid = this.$grid;
        if ( $grid.getGridParam( 'multiselect' ) === true ) {
            return $grid.getGridParam( 'selarrrow' ).length > 0 ? true : locale('selectRowTips');
        }
        return this.lastSelectedRowId ? true : locale('selectRowTips');
    },
    affected: function( zContext ) {
        this.zContext = zContext;
        $( '#' + this._tabid ).trigger( 'reloadGrid' );
    }
} );


/*****************
 ** WEBPACK FOOTER
 ** ./src/index.js
 ** module id = 0
 ** module chunks = 0
 **/